<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderSSPSlim />
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h2>5. {{ $t('internetConnectionTypeState') }}</h2>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('internetConnectionTypeState') }}</div>
        <div>{{ $t(project.serviceReport.internetConnectionTypeState) }}</div>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('electricMeterList') }}</div>
        <div>{{ $t(project.lanConnectionPresentState) }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.storageSerialNumberAttachments"
      fieldName="storageSerialNumberAttachments"
      :maxImages="2"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'InternetAccessPrintPage',
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
